import React from 'react';
import Layout from './Layout';
import { PanelContacto } from './Encabezado';

const CIFRAS = [
    { icono: 'fas fa-solar-panel', valor: '75%', texto: 'de nuestra red usa energía verde' },
    { icono: 'fas fa-network-wired', valor: '150 Km', texto: 'de enlaces de red en Hidalgo' },
    { icono: 'fas fa-home', valor: '+1,000', texto: 'familias conectadas' },
    { icono: 'fas fa-users', valor: '+9,800', texto: 'seguidores en redes sociales' },
];

const VALORES = [
    {
        icono: 'fas fa-wifi',
        titulo: 'Conectividad',
        texto: <>Contamos con <strong>más de 150 kilómetros</strong> de enlaces de red que llegan a localidades remotas de Hidalgo, llevando internet donde más se necesita.</>,
    },
    {
        icono: 'fas fa-graduation-cap',
        titulo: 'Educación',
        texto: <>Becamos instituciones y alumnos, beneficiando a <strong>más de 800 estudiantes</strong> que desarrollan nuevas habilidades y competencias para su futuro.</>,
    },
    {
        icono: 'fas fa-solar-panel',
        titulo: 'Medio Ambiente',
        texto: <>El <strong>75%</strong> de nuestras radiobases usan energía solar. Apostamos por la innovación en energías limpias para reducir nuestra huella ambiental.</>,
    },
];

class Nosotros extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Nosotros">
                    <section className="paginaItmex paginaItmex--hero">
                        <div className="nosotrosHero">
                            <span className="planesItmex-eyebrow coberturaHero-eyebrow">Sobre nosotros</span>
                            <h1 className="heroItmex-title">Internet hecho<br />en Hidalgo</h1>
                            <p className="heroItmex-subtitle">
                                Estamos en la misión de proveer servicio de internet a las zonas más remotas, acercar y enseñar tecnologías de vanguardia a las personas que construyen el futuro de nuestras comunidades.
                            </p>
                            <div className="nosotrosCifras">
                                {CIFRAS.map(cifra => (
                                    <div key={cifra.texto} className="nosotrosCifra">
                                        <i className={cifra.icono}></i>
                                        <b>{cifra.valor}</b>
                                        <span>{cifra.texto}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="planesItmex-header paginaItmex-seccion">
                            <h2 className="tituloItmex tituloItmex--chico">Creemos que el internet debe ser para todos.</h2>
                            <p className="planesItmex-subtitulo">Una empresa orgullosamente hidalguense <i className="fas fa-heart" style={{ color: '#e5484d' }}></i></p>
                        </div>
                        <div className="beneficiosPasos">
                            {VALORES.map(valor => (
                                <div key={valor.titulo} className="beneficiosPaso">
                                    <span className="beneficiosPaso-icono"><i className={valor.icono}></i></span>
                                    <h3 className="paginaItmex-tarjeta-titulo">{valor.titulo}</h3>
                                    <p className="paginaItmex-tarjeta-texto">{valor.texto}</p>
                                </div>
                            ))}
                        </div>

                        <PanelContacto
                            etiqueta="Cobertura"
                            titulo="Estamos llegando a nuevas comunidades"
                            texto="Revisa nuestra cobertura o contáctanos para saber si llegamos a tu zona."
                            ctaTexto="Ver cobertura"
                            ctaTo="/cobertura"
                            whatsappMensaje="Hola, quisiera saber si tienen cobertura en mi comunidad."
                        />
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Nosotros;
